import { Component, Input } from '@angular/core';

@Component({
  selector: 'tp-swipe-hint',
  templateUrl: './swipe-hint.component.html',
  styleUrls: ['./swipe-hint.component.scss']
})
export class SwipeHintComponent {
  @Input()
  isReports: boolean;
}
